// US States, Territories, and Federal Districts for dropdown options
export const US_STATES = [
  // States (alphabetical order)
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },

  // Federal District
  { value: "DC", label: "District of Columbia" },

  // US Territories
  { value: "AS", label: "American Samoa" },
  { value: "GU", label: "Guam" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "PR", label: "Puerto Rico" },
  { value: "VI", label: "U.S. Virgin Islands" },

  // US Minor Outlying Islands (less common but sometimes included)
  { value: "UM", label: "U.S. Minor Outlying Islands" },

  // Armed Forces (for military addresses)
  { value: "AA", label: "Armed Forces Americas" },
  { value: "AE", label: "Armed Forces Europe" },
  { value: "AP", label: "Armed Forces Pacific" },
];

// Other global constants can be added here
export const PHONE_FORMATS = {
  US: "(123) 456-7890",
  INTERNATIONAL: "+1 (123) 456-7890",
};

export const FILE_SIZE_LIMITS = {
  IMAGE_MAX_SIZE: 10 * 1024 * 1024, // 10MB (matches Image API server-side cap)
  DOCUMENT_MAX_SIZE: 10 * 1024 * 1024, // 10MB
};

export const VALIDATION_MESSAGES = {
  REQUIRED: (field) => `${field} is required`,
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_PHONE: "Please enter a valid phone number (e.g., (123) 456-7890)",
  INVALID_ZIP: "Please enter a valid ZIP code (12345 or 12345-6789)",
  FILE_TOO_LARGE: (size) => `File size must be less than ${size}MB`,
  INVALID_FILE_TYPE: "Please select a valid image file",
  DATE_IN_PAST: "Date cannot be in the past",
};

export const REPORT_BUG_HELP_LINK =
  "https://n8n.morph-technologies.com/form/68327794-5339-46cd-95f9-4a906b8cc5be";

export const SAMPLE_REPORT_URL =
  "https://app.dev.morph-technologies.com/compiled-reports/ea928ae0-5e14-4816-9b71-2795f82e3c5f";

export const FREE_TIER_REPORTS_QUOTA = 5;
